export default "__VITE_ASSET__DAhUvS$4__"